import { getSystemSetting, saveSystemSettings, KEY_QUALITY_MAP_ZONES, KEY_QUALITY_MAP_STAGE_ZONE } from 'services/base-services/userSettingServices';

function slugifyZoneCode(label) {
  return String(label || '')
    .trim()
    .replace(/\s+/g, '-');
}

export const DEFAULT_QUALITY_ZONES = [
  { id: 'zone-0', label: 'Despatch', code: 'Despatch', x: 281.6, y: 8671.4, w: 3257, h: 2250.8 },
  { id: 'zone-1', label: 'Astragal bar', code: 'Astragal-bar', x: 2845.8, y: 11010.8, w: 963.2, h: 905 },
  { id: 'zone-2', label: 'Sash Reinforcing', code: 'Sash-reinforcing', x: 4307.859029239934, y: 10909.636569200218, w: 665.3, h: 382.9 },
  { id: 'zone-3', label: 'Cutting Stuga', code: 'Cutting-stuga-1', x: 4615.740518519587, y: 10417.504853800325, w: 1956.2, h: 382.9 },
  { id: 'zone-4', label: 'Sash Welding', code: 'Sash-welding', x: 5131.258576999456, y: 10900.122912280198, w: 1509.3, h: 406.1 },
  { id: 'zone-5', label: 'Cutting Stuga', code: 'Cutting-stuga-2', x: 4617.03566471926, y: 11399.072686159958, w: 1986, h: 394.5 },
  { id: 'zone-6', label: 'Sash Gearing', code: 'Sash-gearing', x: 6824.4, y: 10746.7, w: 536.2, h: 997.8 },
  { id: 'zone-7', label: 'Window Hanging', code: 'Window-hanging', x: 7897.066955517259, y: 10624.407917707742, w: 565.587001723341, h: 802.4376662668656 },
  { id: 'zone-8', label: 'Window Gearing', code: 'Window-gearing', x: 8498.7, y: 10621.6, w: 477.2999999999993, h: 802.3999999999996 },
  {
    id: 'zone-9',
    label: 'Window Inspection',
    code: 'Window-inspection',
    x: 9086.638317739662,
    y: 10616.955079920564,
    w: 484.10054380223846,
    h: 794.676395645547
  },
  { id: 'zone-10', label: 'Window Welding', code: 'Window-welding', x: 9822.7, y: 10641.6, w: 2305.2999999999993, h: 758.3999999999996 },
  { id: 'zone-11', label: 'Glazing', code: 'Glazing', x: 3958.0015869776644, y: 9621.784271247461, w: 772.4321728291825, h: 373.87718760557254 },
  { id: 'zone-12', label: 'Tape and Clean', code: 'Tape-and-clean', x: 4895.524016082603, y: 9609.35892608201, w: 864.4759839173967, h: 390.64107391799007 },
  { id: 'zone-13', label: 'Window QC', code: 'Window-qc', x: 5835.291883075224, y: 9604.686446978945, w: 763.6813995739967, h: 393.19641321545714 },
  { id: 'zone-14', label: 'Beading', code: 'Beading', x: 6727.974206292279, y: 9469.905215594108, w: 752.0257937077213, h: 722.0947844058919 },
  { id: 'zone-15', label: 'Door Hanging', code: 'Door-hanging', x: 7705.4, y: 9481.5, w: 1094.6000000000004, h: 718.5 },
  { id: 'zone-16', label: 'Door Gearing', code: 'Door-gearing', x: 8885.7, y: 9489.5, w: 770.2999999999993, h: 718.5 },
  { id: 'zone-17', label: 'Door Welding', code: 'Door-welding', x: 9867.4, y: 9457.5, w: 644.6000000000004, h: 750.5 },
  { id: 'zone-18', label: 'Door Reinforcing', code: 'Door-reinforcing', x: 10619.5, y: 9457.5, w: 668.5, h: 750.5 },
  { id: 'zone-19', label: 'Window Reinforcing', code: 'Window-reinforcing', x: 11444.8, y: 9449.5, w: 667.2000000000007, h: 774.5 },
  { id: 'zone-20', label: 'Door QC', code: 'Door-qc', x: 4156.5, y: 9155.7, w: 1201.5, h: 336.5 },
  { id: 'zone-21', label: 'Cutting Schirmer', code: 'Cutting-schirmer', x: 9902.7, y: 8180.1, w: 2201.2999999999993, h: 1035.8999999999996 }
];

function withZoneCode(zone) {
  if (zone.code) return zone;
  const fallback = DEFAULT_QUALITY_ZONES.find(z => z.id === zone.id);
  return { ...zone, code: fallback?.code || slugifyZoneCode(zone.label) };
}

export async function loadZoneLayout() {
  const res = await getSystemSetting(KEY_QUALITY_MAP_ZONES);
  if (res.success && res.data?.settingValue) {
    try {
      const zones = JSON.parse(res.data.settingValue);
      if (Array.isArray(zones) && zones.length) return zones.map(withZoneCode);
    } catch (err) {
      console.error('Failed to parse quality map zone layout', err);
    }
  }
  return DEFAULT_QUALITY_ZONES;
}

export async function saveZoneLayout(zones) {
  const res = await saveSystemSettings(KEY_QUALITY_MAP_ZONES, JSON.stringify(zones));
  return res.success;
}

export async function resetZoneLayout() {
  await saveSystemSettings(KEY_QUALITY_MAP_ZONES, JSON.stringify(DEFAULT_QUALITY_ZONES));
  return DEFAULT_QUALITY_ZONES;
}

export const DEFAULT_STATION_PATH_TO_ZONE_CODE = {
  // Despatch
  'loading-bay-1': 'Despatch',
  'loading-bay-2': 'Despatch',
  'loading-bay-3': 'Despatch',
  'loading-bay-4': 'Despatch',
  'loading-bay-5': 'Despatch',
  'loading-bay-6': 'Despatch',
  'loading-bay-7': 'Despatch',
  'loading-bay-8': 'Despatch',
  // Astragal bar
  'astragal-bar-1': 'Astragal-bar',
  // Sash Reinforcing
  'sash-reinforcing-1': 'Sash-reinforcing',
  // Cutting Stuga (2 boxes on the map)
  'stuga-z101-cutting': 'Cutting-stuga-1',
  'stuga-z076-cutting': 'Cutting-stuga-2',
  // Sash Welding
  'sash-welding-1': 'Sash-welding',
  // Sash Gearing
  'sash-gearing-1---new': 'Sash-gearing',
  'sash-gearing-2': 'Sash-gearing',
  'sash-gearing-3': 'Sash-gearing',
  'sash-gearing-hinges': 'Sash-gearing',
  'special-sashes-gearing': 'Sash-gearing',
  // Window Hanging
  'frame-hanging-1': 'Window-hanging',
  'frame-hanging-2': 'Window-hanging',
  'frame-hanging-3': 'Window-hanging',
  'frame-hanging-4': 'Window-hanging',
  // Window Gearing
  'frame-gearing-line-1': 'Window-gearing',
  'frame-gearing-line-2': 'Window-gearing',
  'frame-gearing-line-3': 'Window-gearing',
  // Window Inspection
  'frame-inspection-1': 'Window-inspection',
  'frame-inspection-2': 'Window-inspection',
  'frame-inspection-3': 'Window-inspection',
  // Window Welding
  'crucifix-welding': 'Window-welding',
  'frame-welding-1': 'Window-welding',
  'frame-welding-2': 'Window-welding',
  'new-autoline-welding-1': 'Window-welding',
  'old-autoline-welding-1': 'Window-welding',
  // Glazing
  'glazing-1-new': 'Glazing',
  // Tape and Clean
  'tape-and-clean-1': 'Tape-and-clean',
  'tape-and-clean-2': 'Tape-and-clean',
  'tape-and-clean-3': 'Tape-and-clean',
  'tape-and-clean-4': 'Tape-and-clean',
  // Window QC
  'qc-window-1': 'Window-qc',
  'qc-window-2': 'Window-qc',
  // Beading
  'beading-1-new': 'Beading',
  'beading-2-new': 'Beading',
  'beading-3-new': 'Beading',
  // Door Hanging
  'door-hanging-1': 'Door-hanging',
  'door-hanging-2': 'Door-hanging',
  'door-hanging-3': 'Door-hanging',
  // Door Gearing
  'door-sash-gearing-1': 'Door-gearing',
  'door-sash-gearing-2': 'Door-gearing',
  'threshold-prep-1': 'Door-gearing',
  // Door Welding
  'door-welding-1': 'Door-welding',
  'door-welding-2': 'Door-welding',
  'quad-welder-1': 'Door-welding',
  // Door Reinforcing
  'door-reinforcing-1': 'Door-reinforcing',
  // Window Reinforcing
  'frame-reinforcing-1': 'Window-reinforcing',
  'frame-reinforcing-2': 'Window-reinforcing',
  'frame-rbw-1': 'Window-reinforcing',
  // Door QC
  'qc-door-1': 'Door-qc',
  'qc-door-2': 'Door-qc',
  // Cutting Schirmer
  'schirmer-1-cutting': 'Cutting-schirmer',
  'schirmer-2-cutting': 'Cutting-schirmer',
  'schirmer-3-cutting': 'Cutting-schirmer'
};

export const DEFAULT_STATION_NAMES = {
  'loading-bay-1': 'Loading Bay 1',
  'loading-bay-2': 'Loading Bay 2',
  'loading-bay-3': 'Loading Bay 3',
  'loading-bay-4': 'Loading Bay 4',
  'loading-bay-5': 'Loading Bay 5',
  'loading-bay-6': 'Loading Bay 6',
  'loading-bay-7': 'Loading Bay 7',
  'loading-bay-8': 'Loading Bay 8',
  'astragal-bar-1': 'Astragal Bar 1',
  'sash-reinforcing-1': 'Sash Reinforcing 1',
  'stuga-z076-cutting': 'Stuga Z076 Cutting',
  'stuga-z101-cutting': 'Stuga Z101 Cutting',
  'sash-welding-1': 'Sash Welding 1',
  'sash-gearing-1---new': 'Sash Gearing 1 - New',
  'sash-gearing-2': 'Sash Gearing 2',
  'sash-gearing-3': 'Sash Gearing 3',
  'sash-gearing-hinges': 'Sash Gearing Hinges',
  'special-sashes-gearing': 'Special Sashes Gearing',
  'frame-hanging-1': 'Frame Hanging 1',
  'frame-hanging-2': 'Frame Hanging 2',
  'frame-hanging-3': 'Frame Hanging 3',
  'frame-hanging-4': 'Frame Hanging 4',
  'frame-gearing-line-1': 'Frame Gearing Line 1',
  'frame-gearing-line-2': 'Frame Gearing Line 2',
  'frame-gearing-line-3': 'Frame Gearing Line 3',
  'frame-inspection-1': 'Frame Inspection 1',
  'frame-inspection-2': 'Frame Inspection 2',
  'frame-inspection-3': 'Frame Inspection 3',
  'crucifix-welding': 'Crucifix Welding',
  'frame-welding-1': 'Frame Welding 1',
  'frame-welding-2': 'Frame Welding 2',
  'new-autoline-welding-1': 'New Autoline Welding 1',
  'old-autoline-welding-1': 'Old Autoline Welding 1',
  'glazing-1-new': 'Glazing 1 New',
  'tape-and-clean-1': 'Tape and Clean 1',
  'tape-and-clean-2': 'Tape and Clean 2',
  'tape-and-clean-3': 'Tape and Clean 3',
  'tape-and-clean-4': 'Tape and Clean 4',
  'qc-window-1': 'QC Window 1',
  'qc-window-2': 'QC Window 2',
  'beading-1-new': 'Beading 1 New',
  'beading-2-new': 'Beading 2 New',
  'beading-3-new': 'Beading 3 New',
  'door-hanging-1': 'Door Hanging 1',
  'door-hanging-2': 'Door Hanging 2',
  'door-hanging-3': 'Door Hanging 3',
  'door-sash-gearing-1': 'Door Sash Gearing 1',
  'door-sash-gearing-2': 'Door Sash Gearing 2',
  'threshold-prep-1': 'Threshold Prep 1',
  'door-welding-1': 'Door Welding 1',
  'door-welding-2': 'Door Welding 2',
  'quad-welder-1': 'Quad Welder 1',
  'door-reinforcing-1': 'Door Reinforcing 1',
  'frame-reinforcing-1': 'Frame Reinforcing 1',
  'frame-reinforcing-2': 'Frame Reinforcing 2',
  'frame-rbw-1': 'Frame RBW 1',
  'qc-door-1': 'QC Door 1',
  'qc-door-2': 'QC Door 2',
  'schirmer-1-cutting': 'Schirmer 1 Cutting',
  'schirmer-2-cutting': 'Schirmer 2 Cutting',
  'schirmer-3-cutting': 'Schirmer 3 Cutting'
};

export async function loadStationZoneMap() {
  const res = await getSystemSetting(KEY_QUALITY_MAP_STAGE_ZONE);
  if (res.success && res.data?.settingValue) {
    try {
      const map = JSON.parse(res.data.settingValue);
      if (map && typeof map === 'object') return map;
    } catch (err) {
      console.error('Failed to parse quality map station-zone config', err);
    }
  }
  return DEFAULT_STATION_PATH_TO_ZONE_CODE;
}

export async function saveStationZoneMap(map) {
  const res = await saveSystemSettings(KEY_QUALITY_MAP_STAGE_ZONE, JSON.stringify(map));
  return res.success;
}
